import { render, staticRenderFns } from "./VerkaDashboardHeaderTabs.vue?vue&type=template&id=0aa4413f&"
import script from "./VerkaDashboardHeaderTabs.vue?vue&type=script&lang=ts&"
export * from "./VerkaDashboardHeaderTabs.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaDashboardHeaderTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VTab,VTabs})
